const Indent1 = {
    elemName: '字下げ一',
    type: 'block',
    doc: '一文字分字下げがある箇所を囲むブロックです',
    example: '％字下げ一\nこの部分が字下げされます\n％',
    textTemplate: '{{$1}}',
    htmlTemplate: `<div {{{$htmlId}}} class="Indent1 {{$classes}}">{{{$1}}}</div>`,
    xmlTemplate: `<div rend="indent(-1)" {{{$xmlId}}} {{{$xmlSubtypes}}}>{{{$1}}}</div>`,
    docxTemplate: `<w:p>{{{$1}}}</w:p>`
};
export default Indent1;
// import { ConversionRule } from '../ConversionRule';
// import { KojiASTNode } from '../../KojiAstBuilder';
// export default class Indent1 extends ConversionRule {
// 	get elemName() {
// 		return '字下げ一';
// 	}
// 	toXML(node: KojiASTNode): string {
// 		const text = this.convertChildren(node.children);
// 		let idStr = '',
// 			classesStr = '';
// 		if (node.id) idStr = `xml:id='${node.id}'`;
// 		if (node.classes) classesStr = `subtype='${node.classes.join(' ')}'`;
// 		return `<div rend="indent(-1)" ${idStr} ${classesStr}>${text}<div>`;
// 	}
// 	toText(node: KojiASTNode): string {
// 		const text = this.converter.convertChildren(node.children);
// 		return `${text}`;
// 	}
// 	toHTML(node: KojiASTNode) {
// 		const text = this.convertChildren(node.children);
// 		return `<div class="Indent1 block" >${text}</div>`;
// 	}
// }
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiSW5kZW50MS5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy9jb252ZXJ0ZXIvYmxvY2tfcnVsZXMvSW5kZW50MS50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFFQSxNQUFNLE9BQU8sR0FBbUI7SUFDL0IsUUFBUSxFQUFFLE1BQU07SUFDaEIsSUFBSSxFQUFFLE9BQU87SUFDYixHQUFHLEVBQUUsdUJBQXVCO0lBQzVCLE9BQU8sRUFBRSx3QkFBd0I7SUFDakMsWUFBWSxFQUFFLFFBQVE7SUFDdEIsWUFBWSxFQUFFLGdFQUFnRTtJQUM5RSxXQUFXLEVBQUUsdUVBQXVFO0lBQ3BGLFlBQVksRUFBRSxxQkFBcUI7Q0FDbkMsQ0FBQztBQUVGLGVBQWUsT0FBTyxDQUFDO0FBRXZCLHNEQUFzRDtBQUN0RCxzREFBc0Q7QUFFdEQsd0RBQXdEO0FBQ3hELG9CQUFvQjtBQUNwQixtQkFBbUI7QUFDbkIsS0FBSztBQUVMLHNDQUFzQztBQUN0QyxzREFBc0Q7QUFDdEQsb0JBQW9CO0FBQ3BCLHNCQUFzQjtBQUN0QixnREFBZ0Q7QUFDaEQsMEVBQTBFO0FBQzFFLHlFQUF5RTtBQUN6RSxLQUFLO0FBRUwsdUNBQXVDO0FBQ3ZDLGdFQUFnRTtBQUNoRSxzQkFBc0I7QUFDdEIsS0FBSztBQUVMLCtCQUErQjtBQUMvQixzREFBc0Q7QUFDdEQsd0RBQXdEO0FBQ3hELEtBQUs7QUFDTCxJQUFJIn0=